// extracted by mini-css-extract-plugin
module.exports = {"container":"a10a3f92e9--container--1wUf1","link":"a10a3f92e9--link--2mJJk"};